






























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class UsersSearch extends Vue {

    @Prop({ default: false }) hasError: boolean;
    @Prop({ default: true }) errorCode: string;
    searchTerm: string = '';

    search() {
        this.$emit('search', this.searchTerm);
    }

    completeEmail(suffix: string) {
        if (!this.searchTerm) {
            return;
        }

        this.searchTerm = this.searchTerm.split('@')[0].trim() + suffix;
    }
}
